export const config={
    app:{
            host:"https://bonbon.beyazsaraysarkuteri.nl",
            port: 3000
        },
    api:{
        host:"https://bonbon.beyazsaraysarkuteri.nl/api",
        port: 3000
    },
    kvk:{
        host:"https://bonbon.beyazsaraysarkuteri.nl/kvk",
        port: 3000
    },
    payments:{
        host:"https://bonbon.beyazsaraysarkuteri.nl/payments",
        port: 3000
    },
    ws:{
        host:"wss://bonbon.beyazsaraysarkuteri.nl/ws",
        port: 3001
    },
    webpack: {
        host: "https://bonbon.beyazsaraysarkuteri.nl:8080",
        port: 8080
    },
    token: "AIzaSyCdYmiOMYeEl-35AJeu5s12jEHbuVofhQU"
    }
